// src/components/deck_subdeck/AssignGroupModal.tsx
import React, { useState } from 'react';
import { X } from 'lucide-react';
import { SubdeckGroup } from './SubdeckGroupContainer';
import { getIconComponent } from './groupIcons';

interface AssignGroupModalProps {
    subdeckId: string;
    subdeckName: string;
    currentGroupId: string | null | undefined;
    groups: SubdeckGroup[];
    deckId: string;
    onClose: () => void;
    onSuccess: (subdeckId: string, groupId: string | null) => void;
    onToast: (message: string, type: 'success' | 'error') => void;
}

const renderGroupIcon = (g: SubdeckGroup) => {
    if (g.iconType === 'image' && g.iconUrl) {
        return <img src={g.iconUrl} alt="" style={{ width: 18, height: 18, objectFit: 'cover', borderRadius: 3 }} />;
    }
    const Ic = getIconComponent(g.iconName || 'Layers');
    return <Ic size={16} color={g.color} />;
};

const AssignGroupModal: React.FC<AssignGroupModalProps> = ({
    subdeckId, subdeckName, currentGroupId, groups, deckId,
    onClose, onSuccess, onToast
}) => {
    const [selected, setSelected] = useState<string | null>(currentGroupId || null);
    const [saving, setSaving] = useState(false);

    const handleConfirm = async () => {
        setSaving(true);
        try {
            const r = await fetch(`/api/decks/${deckId}/subdecks/${subdeckId}/group`, {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`
                },
                body: JSON.stringify({ groupId: selected })
            });
            if (r.ok) {
                onSuccess(subdeckId, selected);
                onToast('Grupo atualizado!', 'success');
                onClose();
            } else {
                const e = await r.json();
                onToast(e.message || 'Erro ao atualizar grupo', 'error');
            }
        } catch {
            onToast('Erro ao atualizar grupo', 'error');
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="sdp-dialog-overlay" onClick={onClose}>
            <div className="sdp-dialog sdp-assign-group-dialog" onClick={e => e.stopPropagation()}>
                <div className="sdp-dialog-header">
                    <h2 className="sdp-dialog-title">Mover para grupo</h2>
                    <p className="sdp-dialog-subtitle">"{subdeckName}"</p>
                    <button className="sdp-dialog-close" onClick={onClose}><X size={18} /></button>
                </div>

                <div className="sdp-assign-group-list">
                    {/* Opção: Sem grupo */}
                    <button
                        className={`sdp-assign-group-option ${selected === null ? 'sdp-assign-group-option--selected' : ''}`}
                        onClick={() => setSelected(null)}
                    >
                        <span className="sdp-assign-group-option-icon">📂</span>
                        <span className="sdp-assign-group-option-name">Sem grupo</span>
                    </button>

                    {groups.map(g => (
                        <button
                            key={g._id}
                            className={`sdp-assign-group-option ${selected === g._id ? 'sdp-assign-group-option--selected' : ''}`}
                            style={{ '--option-color': g.color } as React.CSSProperties}
                            onClick={() => setSelected(g._id)}
                        >
                            <span className="sdp-assign-group-option-icon">{renderGroupIcon(g)}</span>
                            <span className="sdp-assign-group-option-name">{g.name}</span>
                        </button>
                    ))}
                </div>

                <div className="sdp-dialog-footer">
                    <button className="sdp-dialog-btn sdp-dialog-btn--cancel" onClick={onClose}>Cancelar</button>
                    <button
                        className="sdp-dialog-btn sdp-dialog-btn--confirm"
                        onClick={handleConfirm}
                        disabled={saving}
                    >
                        {saving ? 'Salvando...' : 'Confirmar'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AssignGroupModal;
